<template>
  <form @submit.prevent="onSubmit">
    <v-card>
      <v-card-title class="headline">
        New example
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field
                label="Content*"
                v-model="content"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field
                label="Description"
                v-model="description"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">Close</v-btn>
        <v-btn type="submit" color="blue darken-1" text>Create</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddTerm",
  props: ["onFinish"],
  data: () => ({
    content: "",
    description: ""
  }),
  computed: mapGetters(["item"]),
  methods: {
    ...mapActions(["addExample"]),
    onSubmit() {
      this.addExample({
        itemId: this.item.id,
        example: {
          content: this.content,
          description: this.description
        }
      });
      this.onFinish();
      this.content = "";
      this.description = "";
    },
    onClose() {
      this.onFinish();
    }
  }
};
</script>
